import { addComposeLinkViewState } from '../actions/internalActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
mutator(addComposeLinkViewState, function (actionMessage) {
    var store = getStore();
    var composeLinkViewState = {
        linkId: actionMessage.linkId,
        isContextMenuOpen: false,
    };
    store.composeLinks.set(actionMessage.linkId, composeLinkViewState);
});
//# sourceMappingURL=composeLinkViewMutators.js.map